import { Component } from '@theme/component';

class BagMenu extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.addEventListener('click', this.choose, options);
    this.addEventListener('keydown', event => {
      if (event.key === ' ' && event.target instanceof Element && event.target.closest('[data-bag-category]')) {
        event.preventDefault();
        event.target.click();
      }
      if (event.key === 'Escape' && this.closest('.ms-menu-drawer')) {
        const expanded = this.querySelector('[data-bag-category][aria-expanded="true"]');
        if (expanded) {
          event.preventDefault();
          event.stopPropagation();
          this.select(null);
          expanded.focus({ preventScroll: true });
        }
      }
    }, options);
    this.closest('details')?.addEventListener('toggle', event => {
      if (event.target.open) this.select(this.dataset.default);
    }, options);
    this.arrangePanels();
    this.select(this.dataset.default);
  }
  updatedCallback() {
    super.updatedCallback();
    this.arrangePanels();
    this.select(this.dataset.default);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.controller?.abort();
  }
  arrangePanels() {
    if (!this.closest('.ms-menu-drawer')) return;
    const links = [...this.querySelectorAll('[data-bag-category]')];
    this.querySelectorAll('[data-bag-panel]').forEach(panel => {
      const link = links.find(item => item.dataset.bagCategory === panel.dataset.bagPanel);
      if (!link) return;
      link.setAttribute('role', 'button');
      if (link.nextElementSibling !== panel) link.after(panel);
    });
    const preview = this.querySelector('.ms-bag-preview');
    if (preview) preview.hidden = true;
  }
  choose = event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-bag-category]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopPropagation();
    if (this.closest('.ms-menu-drawer') && link.getAttribute('aria-expanded') === 'true') {
      this.select(null);
      link.focus({ preventScroll: true });
      return;
    }
    this.select(link.dataset.bagCategory, true);
  };
  select(handle, focus = false) {
    const links = [...this.querySelectorAll('[data-bag-category]')];
    const selected = handle === null ? null : links.find(link => link.dataset.bagCategory === handle) || links[0];
    links.forEach(link => {
      const active = link === selected;
      link.classList.toggle('is-active', active);
      link.setAttribute('aria-expanded', String(active));
      link.querySelector('.ms-bag-category-sign').textContent = active ? '−' : '+';
    });
    this.querySelectorAll('[data-bag-panel]').forEach(panel => {
      panel.hidden = panel.dataset.bagPanel !== selected?.dataset.bagCategory;
    });
    const list = this.querySelector('[data-bag-categories]');
    const anchor = list?.querySelector('[data-bag-all]');
    if (!this.closest('.ms-menu-drawer') && selected && anchor && anchor.nextElementSibling !== selected) anchor.after(selected);
    if (focus) selected?.focus({ preventScroll: true });
  }
}
if (!customElements.get('ms-bag-menu')) customElements.define('ms-bag-menu', BagMenu);
